import isEmpty from "is-empty";
import styles from "src/styles/agGridCustom.module.scss";
import {
    isKsdAccountNoValid,
    isKsfcAccountNoValid,
} from "src/utils/validators";

export const isEveryElementUnique = (arr) => {
    return new Set(arr).size === arr.length;
};

export const isAccountNameValid = (accountName) => {
    return !isEmpty(accountName) && accountName.length <= 50;
};

const isElementUnique = (el, arr) => arr.filter((a) => a === el).length === 1;

export const defaultColDef = {
    resizable: false,
    sortable: false,
    filter: false,
    headerClass: styles.agHeaderCenterAlign,
    tooltipComponent: "txTooltip",
    menuTabs: [],
};

export const intermediaryAccountsColumnDefs = [
    {
        headerName: "Name",
        colId: "Details Name",
        field: "name",
        flex: 1,
        editable: (params) => params.data.isNew,
        cellClassRules: {
            [styles.agConfirmEditable]: (params) =>
                params.colDef.editable(params),
            [styles.agNewValueCellError]: (params) =>
                params.colDef.editable(params) &&
                (!isAccountNameValid(params.value) ||
                    !isElementUnique(
                        params.value,
                        params.context.allAccountNames
                    )),
        },
        tooltipValueGetter: (params) => {
            return { value: params.value };
        },
        tooltipComponentParams: (params) => {
            if (params.value.value.length >= 10) {
                return { type: "accountName", value: params.value };
            } else {
                return undefined;
            }
        },
    },
    {
        headerName: "Intermediary",
        colId: "Details Intermediary",
        field: "type",
        flex: 1,
        editable: (params) => params.data.isNew,
        cellEditor: "agRichSelectCellEditor",
        cellEditorPopup: true,
        cellEditorParams: {
            values: ["KSD", "KSFC"],
            cellRenderer: "dropdown",
        },
        cellClassRules: {
            [styles.agConfirmEditable]: (params) =>
                params.colDef.editable(params),
            [styles.agNewValueCellError]: (params) => !params.value,
        },
    },
    {
        headerName: "Account Code",
        colId: "Details Code",
        field: "accountNo",
        flex: 1,
        editable: (params) => params.data.isNew && !!params.data.type,
        cellClassRules: {
            [styles.agNewValueCellError]: (params) => {
                if (!params.colDef.editable(params)) return false;
                if (!params.value) return true;
                if (
                    !isElementUnique(
                        params.value,
                        params.context.allAccountCodes
                    )
                )
                    return true;
                if (params.data.type === "KSD")
                    return !isKsdAccountNoValid(params.value);
                return !isKsfcAccountNoValid(params.value);
            },
            [styles.agConfirmEditable]: (params) =>
                params.colDef.editable(params),
        },
    },
    {
        headerName: "Delete",
        colId: "Details Delete",
        field: "delete",
        width: 60,
        cellRenderer: "deleteButton",
    },
];
